import { useState } from "react";
import { Grid } from "@material-ui/core";
import beverageTitleImage from '../common/images/drinks/beverages_header.png';
import BeveragesMenuContainer from "./components/beveragesMenuContainer";
import PictureModal from "./components/pictureModal";
import Title from '../common/title';

const BeveragesMenu = () => {
  const [showPictureModal, setShowPictureModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleItemSelect = (item) => {
    setSelectedItem(item);
    setShowPictureModal(true);
  }

  const handleCloseModal = () => {
    setShowPictureModal(false);
    setSelectedItem(null);
  }

  return (
    <div>
      {showPictureModal && <PictureModal item={selectedItem} closeModal={handleCloseModal} />}
      <Grid container justify="center">
        <Grid item xs={12}>
          <Title img={beverageTitleImage} h1="Beverages" h3="Our" />
        </Grid>
        <Grid item xs={12} sm={10} lg={8}>
          <BeveragesMenuContainer selectItem={handleItemSelect} />
        </Grid>
      </Grid>
    </div>
  );
};

export default BeveragesMenu;
